/* eslint-disable react-hooks/exhaustive-deps */
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { Grid } from "@splidejs/splide-extension-grid";
import React from "react";
import Image from "next/image";
import { MediaProp } from "../../../types/media.interface";

interface ImageSliderProps {
  Media: MediaProp[];
}

const ImageSlider: React.FC<ImageSliderProps> = ({ Media }) => {
  return Media.length === 0 ? (
    <div>
      <Image
        src="/images/fallback.webp"
        alt="No Image"
        width={920}
        height={250}
        layout="responsive"
      />
    </div>
  ) : (
    <div className="z-1">
      <Splide
        extensions={{ Grid }}
        options={{
          rewind: true,
          pagination: false,
          type: "slide", // Ensure this is set
          speed: 400, // Animation speed in milliseconds (e.g., 400ms)
          easing: "ease", // Smooth easing function
          height: "30rem",
          gap: "4px",
          perPage: 2,
          perMove: 1,
          drag: true, // Enable smooth drag on mobile
          dragMinThreshold: 10, // Minimum drag distance to trigger a slide change
          flickPower: 100, // Adjust flick sensitivity
          flickMaxPages: 1,
          grid: {
            dimensions: [
              [1, 1],
              [2, 2],
            ],
            gap: {
              row: "28px", // Gap between rows
              col: "4px", // Gap between columns
            },
          },
          breakpoints: {
            750: {
              height: "220px",
              grid: false,
              gap: 0,
              perPage: 1,
              perMove: 1,
            },
            900: {
              gap: "2px",
              perPage: 2,
              perMove: 1,
              type: "slide", // Ensure this is set
              speed: 400, // Animation speed in milliseconds (e.g., 400ms)
              easing: "ease",
              grid: {
                dimensions: [
                  [1, 1],
                  [2, 1],
                ],
                gap: {
                  row: "2px",
                  col: "2px",
                },
              },
            },
          },
        }}
      >
        {Media.map((img: MediaProp, index: number) => (
          <SplideSlide key={img.MediaObjectID}>
            {index === 0 ? (
              <div className="min-h-[250px] h-full relative w-full">
                <Image
                  priority
                  layout="fill"
                  src={img?.MediaURL || "/images/fallback.webp"}
                  alt={img.ResourceRecordKey + " image No. " + index + 1}
                  objectFit="cover"
                />
              </div>
            ) : (
              <div className="min-h-[250px] h-full relative w-full">
                <Image
                  layout="fill"
                  src={img?.MediaURL || "/images/fallback.webp"}
                  alt={img.ResourceRecordKey + " image No. " + index + 1}
                  objectFit="cover"
                />
              </div>
            )}
          </SplideSlide>
        ))}
      </Splide>
    </div>
  );
};

export default ImageSlider;
